import { Flex, Text } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { SupplierArticleItem } from '@texas/api/endpoints/suppliersApi';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { HoverCard } from '@texas/components/shared/HoverCard';
import { ProjectHoverCard } from '@texas/components/shared/hovercards/ProjectHoverCard';
import { Icons } from '@texas/components/shared/Icons';
import { Locale } from '@texas/i18n/types';
import { formatDate } from '@texas/utils/helpers/dateHelper';
import { TFunction } from 'i18next';

const columnHelper = createColumnHelper<SupplierArticleItem>();

export const supplierArticlesColumns = (t: TFunction) => {
  return [
    columnHelper.accessor('itemCode', {
      header: t('general.itemCode'),
      cell: (info) => {
        return (
          <AngularNavLink
            to="article"
            navobj={{ articleId: info.row.original.articleId }}
          >
            {info.getValue()}
          </AngularNavLink>
        );
      },
    }),
    columnHelper.accessor('variantName', {
      header: t('variant.variant'),

      cell: (info) => {
        return (
          <AngularNavLink
            to="variant.versions"
            navobj={{
              articleId: info.row.original.articleId,
              variantId: info.row.original.variantId,
            }}
          >
            <Flex w="200px" whiteSpace="normal">
              <Text>{info.getValue()}</Text>
            </Flex>
          </AngularNavLink>
        );
      },
    }),
    columnHelper.accessor('customerName', {
      header: t('general.brand'),
      cell: (info) => (
        <AngularNavLink
          to="customer"
          navobj={{ customerId: info.row.original.customerId }}
        >
          {info.getValue()}
        </AngularNavLink>
      ),
    }),
    columnHelper.accessor('projectNumber', {
      header: t('general.project'),
      cell: (info) => {
        const projectNumber = info.getValue();
        const customerId = info.row.original.customerId;
        return (
          <HoverCard content={<ProjectHoverCard customerId={customerId} />}>
            <Text>{projectNumber ?? ''}</Text>
          </HoverCard>
        );
      },
    }),
    columnHelper.accessor('isMainPurchaseInfo', {
      header: t('suppliers.articles.isMainSupplier'),
      cell: (info) => (info.getValue() ? <Icons.Checkmark /> : ''),
      enableSorting: false,
    }),
    columnHelper.accessor('isSynced', {
      header: t('garp.syncedToGarp'),
      cell: (info) => (info.getValue() ? <Icons.Checkmark /> : ''),
    }),
    columnHelper.accessor('created', {
      header: t('article.created'),
      cell: (info) => {
        const val = info.getValue();
        return val ? formatDate(Locale.En, val) : '';
      },
    }),
    columnHelper.accessor('productGroupName', {
      header: t('general.productGroup'),
      cell: (info) => info.getValue() ?? '',
    }),
    columnHelper.accessor('branchIdentifier', {
      header: t('general.branch'),
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('productDeveloperName', {
      header: t('suppliers.articles.productDeveloper'),
      cell: (info) => info.getValue() ?? '',
    }),
    columnHelper.accessor('garpState', {
      header: t('general.state'),
      cell: (info) => info.getValue() ?? '',
    }),
  ];
};
